import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import styles
import './App.css';

// Import Components and Pages
import NavBar from './components/NavBar';
import BioSection from './components/BioSection';
import LandingPage from './pages/LandingPage';
import CourseShowcase from './pages/CourseShowcase';
import AboutUs from './pages/AboutUs';
import ResourcePage from './pages/ResourcePage';

function App() {
    // Renamed for clarity
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    // <-- 1. Created specific handlers for opening and closing
    const openContactModal = () => {
        setIsContactModalOpen(true);
    };

    const closeContactModal = () => {
        setIsContactModalOpen(false);
    };

    return (
        <Router>
            <div className="app-container">
                {/* <-- Pass the 'open' handler to the NavBar */}
                <NavBar onContactClick={openContactModal} />

                {/* <-- Check the new state variable */}
                {isContactModalOpen && (
                    // <-- 2. Added onClick to the overlay to close it
                    <div className="contact-overlay" onClick={closeContactModal}>

                        {/* <-- 3. Added stopPropagation so clicks *inside* the modal don't close it */}
                        <div className="contact-modal" onClick={(e) => e.stopPropagation()}>

                            {/* <-- Use the 'close' handler for the button */}
                            <button className="close-contact-button" onClick={closeContactModal}>×</button>
                            <h2>Get in Touch</h2>
                            <p><strong>Phone:</strong> <a href="tel:+64 218 63279">+64 218 63279</a></p>
                            <p><strong>Email:</strong> <a href="mailto:whittendamon@gmail.com">whittendamon@gmail.com</a></p>
                        </div>
                    </div>
                )}

                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/course-showcase" element={<CourseShowcase />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/resources/:courseSlug" element={<ResourcePage />} />
                    </Routes>
                </main>

                <BioSection />

                <footer className="app-footer">
                    <p>© {new Date().getFullYear()} Adult Literacy and Numeracy. All rights reserved.</p>
                    <p>Empowering Minds, Enriching Futures.</p>
                </footer>
            </div>
        </Router>
    );
}

export default App;